module.exports = __webpack_public_path__ + "daccordLogo.png?8e5babc45bf8eb233c7eef20a9838d8e";


//////////////////
// WEBPACK FOOTER
// ./Content/src/assets/MyProgress/daccordLogo.png
// module id = 870
// module chunks = 1